import { deepmerge } from '@mui/utils';

export interface ColorPalette {
  PRIMARY: string;
  PRIMARY_LIGHT: string;
  PRIMARY_DARK: string;
  FOCUS: string;
  BUTTON_TEXT: string;
  TEXT: string;
  DISABLED_TEXT: string;
  LINK: string;
  FOOTER: string;
  HOVER: string;
  BORDER: string;
  ERROR: string;
  WARNING: string;
  BACKGROUNDS: {
    BUTTON: string;
    ICON_BUTTON: string;
    DEFAULT: string;
    DISABLED: string;
    PAPER: string;
    SUBTLE: string;
    CANVAS: string;
  };
}

const BASE_COLORS = {
  PRIMARY: '#9BCBEB',
  PRIMARY_LIGHT: '#D5E9F7',
  PRIMARY_DARK: '#232323',
  FOCUS: '#5FA0E5',
  BUTTON_TEXT: '#FBFBFB',
  TEXT: '#232323',
  DISABLED_TEXT: '#767676',
  LINK: '#3E518A',
  FOOTER: '#3E518A',
  HOVER: '#596166',
  BORDER: '#E1E1E1',
  ERROR: '#C62828',
  WARNING: '#FD9A02',
  BACKGROUNDS: {
    BUTTON: '#232323',
    ICON_BUTTON: '#232323',
    DEFAULT: '#EAF4FB',
    DISABLED: '#EFEFEF',
    PAPER: '#FBFBFB',
    SUBTLE: '#EEEFF0',
    CANVAS: '#FFFFFF',
  },
};

export const PROBONIO_COLORS: ColorPalette = deepmerge(BASE_COLORS, {});

export const BLS_COLORS: ColorPalette = deepmerge(BASE_COLORS, {
  PRIMARY: '#95C11E',
  PRIMARY_LIGHT: '#EAF3D2',
  PRIMARY_DARK: '#749900',
  FOCUS: '#212120',
  LINK: '#5B7900',
  FOOTER: '#FFFFFF',
  HOVER: '#A8CB49',
  BORDER: '#C6C6C6',
  BUTTON_TEXT: '#212120',
  BACKGROUNDS: {
    BUTTON: '#95C11E',
    PAPER: '#FFF',
  },
});
